interface V3IconSidebarLayoutProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconSidebarLayout = ({}: V3IconSidebarLayoutProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
            <path
                stroke="#ABB0BA"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 7h13M9 12h10M9 17h10M4 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
            />
        </svg>
    );
};
